import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {noop} from '@Utils/general.util';
import {ClickableDiv} from '@Components/clickable-div';
import styles from './logo-with-back-btn.module.scss';
import type {LogoWithBackBtnProps} from '@Components/logo-with-back-btn/logo-with-back-btn.types';
import {LogoWithBackBtnType} from '@Components/logo-with-back-btn/logo-with-back-btn.types';

export function LogoWithBackBtn({
  onBack = noop,
  onLogoClick = noop,
  isMobileLogo = false,
  disableBackButton = false,
  hideBackButton = false,
  logoWithBackBtnType = LogoWithBackBtnType.DEFAULT,
}: LogoWithBackBtnProps): ReactElement<any> {
  const isLogoWithBackBtnTypeDark = logoWithBackBtnType === LogoWithBackBtnType.DARK;

  const getLogoURL = (): string => {
    if (!isMobileLogo) {
      return isLogoWithBackBtnTypeDark ? window.PMW.util.asset_url('images/logo-on-white.png') : window.PMW.util.asset_url('images/logo-postermaker.svg');
    }
    return isLogoWithBackBtnTypeDark ? window.PMW.util.asset_url('images/logo-mobile-dark.svg') : window.PMW.util.asset_url('images/logo-mobile.svg');
  };

  const getBackButtonIcon = (): ReactElement<any> | null => {
    return (
      <Icon
        onClick={onBack}
        icon="icon-arrow-left"
        size={IconSize.SIZE_ICON_20}
        isDisabled={disableBackButton}
        shape={IconShape.SQUARE}
        type={isLogoWithBackBtnTypeDark ? IconType.GHOST : IconType.DARK_GHOST}
        className={`spacing-m-r-2 ${hideBackButton ? '_hidden' : ''}`}
      />
    );
  };

  return (
    <div className="flex-h-row flex-center">
      {getBackButtonIcon()}
      <ClickableDiv
        onClick={onLogoClick}
        className={`_cursor-pointer flex-center ${styles.imageContainerWeb} ${!isMobileLogo ? styles.imageContainerWeb : styles.imageContainerMobile}`}
      >
        <img className={`${styles.logo} ${!isMobileLogo ? styles.logo : styles.logoWidthMobile}`} src={getLogoURL()} alt={window.i18next.t('pmwjs_logo')} />
      </ClickableDiv>
    </div>
  );
}
